import React, { useEffect, useRef, useState } from "react";
import { Tabs, Tab, Box, Button, Typography, Stack, Drawer } from "@mui/material";
import {
  DndContext,
  PointerSensor,
  closestCenter,
  useDroppable,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { useTranslation } from "react-i18next";
import ScreenSearchSection from "../../../common/chatComponents/ScreenSearchSection";
import { styled } from "@mui/system";
import "../index.css";
import { StyledChatContainer } from "../../../Styled";
import CreateGroup from "../Drawer/CreateGroup";
import ChatMoreMenu from "../Drawer/ChatMoreMenu";
import InputDialogComponent from "../../../components/InputDialog";
import GroupMemberDrawer from "../Drawer/GroupMemberDrawer";
import LanguageList from "../Drawer/LanguageList";
import AddMemberGroupDrawer from "../Drawer/AddMemberGroupDrawer";
import { GroupLevelArkchatPermission } from "../../../utils/constant";
import YouTubeAttachmentDrawer from "../Drawer/YouTubeAttachmentdrawer";
import GoogleAttachmentDrawer from "../Drawer/GoogleAttachmentDrawer";
import CloudStorageDrawer from "../Drawer/CloudStorageDrawer";
import MediaFiles from "../Drawer/MediaFiles";
import selectGroupicon from "../../../assets/images/chats/select_group.svg";
import GrouMembeMessageReadStatus from "../Drawer/GroupMemberReadStatus";
import groupVector from "../../../assets/images/chats/groupVector.svg";
import TaskListTab from "../Task/TaskListTab";
import ApprovalListTab from "../Approval/ApprovalListTab";
import WorkTrackingListTab from "../WorkTracking/WorkTrackingListTab";
import PerformanceTab from "../Performance/PerformanceTab";
import AIQueryPage from "../AI/AIQueryPage";
import useTabState from "../../../customHooks/useTabState";
import useStableCallbacks from "../../../customHooks/useStableCallbacks";
import MessageList from "../MessageComponent/MessageList";
import TaskUpdate from "../MessageComponent/TaskUpdate";
import LoadingSpinner from "../../../common/LoadingSpinner/LoadingSpinner";
import { createStyledIndicatorButton } from "../../../common/StyledComponents/SideBarComponents";
import AssignTaskDrawers from "../Drawer/AssignTaskDrawers";
import SearchInputFromGroupInfo from "./SearchInputFromGroupInfo";
import { fontSizeSchemes, leftOverlayDrawerSx, rightOverlayDrawerSx } from "../../../assets/commonFunction";
import LableToolTip from "../../../common/LableToolTip";
import MessageThreadDrawer from "../MessageComponent/MessageThreadDrawer";
import useAppSelectors from "../../../customHooks/useAppSelectors";
import session, { canManageGroup } from "../../../utils/helper";
import ChatInputWrapper from "../ChatInputWrapper";
import ThreadChatInputControl from "../MessageComponent/ThreadChatInputControl";
import SubTaskAISuggestionDrawer from "../MessageComponent/SubTaskAISuggestionDrawer";
import FileDropZone from "../../../common/FileDropZone";
import { useDispatch, useSelector } from "react-redux";
import { showToastMsg } from "../../../appStore/actions/global/action";
import { generateUniqueId } from "../../../utils/copytoClipboard";
import Topics from "../Topics/Topics";
import Threads from "../Threads/Threads";
import FilePreview from "../FilePreview/FilePreview";
import GroupInfoHeader from "./GroupInfoHeader";
import { SmallIcon } from "../../../common/chatComponents/ScreenSearchSection";
import {
  handleScrollToBottom,
  handleStarMsgScreen,
} from "../../../appStore/actions/AppState/action";
import {
  DEFAULT_PINNED_SHORTCUTS,
  MAX_PINNED_SHORTCUTS,
  PINNED_SHORTCUTS_DROPZONE_ID,
  getChatShortcutMeta,
} from "../../../utils/chatShortcuts";
const classes = {
  Tabs: {
    minHeight: "38px",
    "& .MuiTabs-flexContainer": {
      gap: "0.6rem",
      paddingLeft: "0.8rem",
      alignItems: "center",
      minHeight: "38px",
    },
    "& .MuiTabs-indicator": {
      display: "none",
    },
  },
  tabs: {
    color: "#000000",
    backgroundColor: "#ffff",
    border: "1px solid black",
    borderRadius: "4px",
    textTransform: "none",
    minWidth: "unset",
    minHeight: "unset",
    height: "30px",
    padding: "2px 8px",
    fontSize: "0.75rem",
    fontWeight: 400,
    "&.Mui-selected": {
      color: "#fff",
      backgroundColor: "#183243",
      borderColor: "#183243",
    },
  },
  panelBox: {
    backgroundColor: "#F9F8F8",
    height: "calc(100vh - 107px)",
    minWidth: "19vw",
    maxWidth: "19vw",
    overflow: "hidden",
    // marginLeft: "5px",
    marginRight: "5px",
    marginTop: "5px",
    boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.15)",
  },
  panelBoxCollapsed: {
    backgroundColor: "#F9F8F8",
    height: "calc(100vh - 107px)",
    minWidth: "2.5rem",
    maxWidth: "2.5rem",
    overflow: "hidden",
    // marginLeft: "5px",
    marginRight: "5px",
    marginTop: "5px",
    boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.15)",
  },
  // Takes over the Topics+Threads slot at their combined both-expanded width
  // (2 x panelBox), regardless of whichever collapse/open state those two
  // panels were actually in — a fixed, predictable footprint for Preview.
  // Same height formula as panelBox/panelBoxCollapsed since it sits in the
  // same flex row below the chat sub-header — not the overlay Drawers'
  // calc(100vh - 4rem), which clips the bottom of the preview.
  previewPanelBox: {
    backgroundColor: "#F9F8F8",
    height: "calc(100vh - 107px)",
    minWidth: "38vw",
    maxWidth: "38vw",
    overflow: "hidden",
    marginRight: "5px",
    marginTop: "5px",
    boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.15)",
  },
};

const TabPanel = ({ children, value, index }) => (
  <div hidden={value !== index}>{value === index && <Box>{children}</Box>}</div>
);

export const StyledSubHeadingBox = styled(Box)({
  display: "flex",
  alignItems: "center",
  backgroundColor: "#efefef",
  minHeight: "38px",
});

export const StyledSubHeadingButton = styled(Button)({
  backgroundColor: "#DB0011",
  // padding: "0.3rem 0.5rem",
  padding: "4px 5px",
  color: "#fff",
  fontSize: "0.8rem",
  minWidth: "unset",
  minHeight: "unset",
  borderRadius: "0.15rem",
  boxShadow: "none",
  textTransform: "none",
  display: "flex",
  alignItems: "center",
  // gap: "2px",
  gap: "4px",
  "&:hover": {
    backgroundColor: "#DB0011",
    color: "#fff",
  },
});

// Must be a real descendant of <DndContext> for useDroppable to register
// with it — calling the hook in the same component that renders
// <DndContext> as a child leaves droppableRects empty and drops silently
// never register (verified: over stayed null for the whole gesture).
const PinnedShortcutsRow = ({
  pinnedShortcuts,
  isShortcutVisible,
  showStarMessage,
  selectedGroup,
  onShortcutAction,
}) => {
  const { setNodeRef } = useDroppable({ id: PINNED_SHORTCUTS_DROPZONE_ID });

  return (
    <Box ref={setNodeRef} display="flex" alignItems="center" px={"0.5rem"}>
      {pinnedShortcuts.filter(isShortcutVisible).map((shortcutId) => {
        const meta = getChatShortcutMeta(shortcutId);
        if (!meta) return null;
        const isActive = shortcutId === "star" && showStarMessage;
        return (
          <LableToolTip key={shortcutId} title={meta.label}>
            <Box display="flex" mr={0.75}>
              <Button
                variant="outlined"
                disabled={!selectedGroup}
                onClick={() => onShortcutAction(shortcutId)}
                sx={{
                  backgroundColor: isActive ? "#183243" : "#ffff",
                  borderColor: isActive ? "#183243" : "#000000",
                  color: "#000000",
                  width: "30px",
                  height: "30px",
                  minWidth: "unset",
                  minHeight: "unset",
                  padding: "4px",
                  borderRadius: "0.15rem",
                  "&:hover": {
                    backgroundColor: isActive ? "#183243" : "#ffff",
                    borderColor: isActive ? "#183243" : "#000000",
                    color: "#000000",
                  },
                }}
              >
                <SmallIcon
                  src={isActive ? meta.activeIcon : meta.icon}
                  alt={meta.label}
                  style={
                    isActive ? { filter: "brightness(0) invert(1)" } : undefined
                  }
                />
              </Button>
            </Box>
          </LableToolTip>
        );
      })}
    </Box>
  );
};

const MyTabs = ({
  isSyncing,
  isCreategroupOpen,
  handleClosegroupdrawer,
  setPricingDrawerOpen,
  handlesavearkchatgroup,
  isRequired,
  groupname,
  setGroupname,
  handleNameChange,
  handleDescriptionChange,
  setisTopicOpen,
  isTopicOpen,
  setMoveTopicTriggered,
  setMoveTopicMsgId,
  isMoveTopicTriggered,
  moveTopicMsgId,
  handleSelectedTopic,
  newMessages,
  setNewMessages,
  handleCloseAddPeopleDrawer,
  pubnub,
  setShowSidebar,
  showSidebar,
  setFilterChecked,
  filterChecked,
  isAiQueryHistory,
  setAiQueryHistory,
  isShareAiText,
  setShareAiText,
  setAddpeopledarwer,
  isAddPeopledarwer,
  newGroupName,
  newGroupDescription,
  setNewGroupName,
  setSideBarOpen,
  isSideBarOpen
}) => {
  const { t } = useTranslation();
  // Panel toggles of the Track Work/Task/Approval tabs. Kept here: reading them
  // from a second useChatState() also re-ran its dashboard load (chat list,
  // message sync, first group's members/topics/messages) on every mount.
  const [filterActive, setFilterActive] = useState(true);
  const [groupActive, setGroupActive] = useState(true);
  const [sidebarLeft, setSidebarLeft] = useState(true);
  const { isGroupmenuOpen, isThreadScreenFromTaskApproval, setLanguageMenuOpen, isLanguageMenuOpen, isGroupmembermenu, delrequired, setdeleteInputVal, delInputval, setDeletegroupmenu, isDeleteGroupmenu, setEditGroupmenu, isEditGroupmenu, setNotificationpreferenceModal, isNotificationpreferenceModalOpen, set24Hour, is24Hour, setDDMMYY, isDDMMYY, setMMDDYY, isMMDDYY, setYYMMDD, isYYMMDD, setDateFormate, setMediaFilesOpen, isMediaFilesOpen, setDatAndTimeModal, isdateAndTimeModalOpen, setReadstatusdrawer, readStatusdrawer, setPrivateDisableChat, isPrivateDisableChat, setdisableprivatechat, isdisableprivatchat, setReplyParentMsg, replyParentMsg, setFileAttachment, fileAttachment, attachmentdrawer, setSelectedAnswer, selecteAnswer, setShowStaredAiHistory, showStaredAiHistory, setShowTempQuery, showTempQuery, setTempAiQuery, tempAiQuery, setAiQueryValue, aiQueryValue, selectRecipientsDrawerOpen, setSelectRecipientsDrawerOpen, setAttachment, isTaskTypeModalOpen, setIsTaskTypeModalOpen, isThreadTaskTypeModalOpen, setIsThreadTaskTypeModalOpen, attachment, setMessageType, isEmailChecked, isMobileChecked, setEmailChecked, setMobileChecked, selectedRecipients, setSelectedRecipients, externalGroupMember, setExternalGroupMemebr, taskAssignedUser, setTaskAssignedUser, dueTime, setDueTime, dueDate, setDueDate, priority, setPriority, isRepeat, setRepeat, repeatType, setRepeatType, selecteRepeatEvery, setSelectedRepeatEvery, setStepper, stepper, setTaskData, taskData, isTaskUpdateOpen, setTaskUpdateOpen, msgType, setUpdateTaskApprovalMsg, updateTaskApprovalMsg, checkedType, setCheckedType, progress, groupList, currentUserData, setThreadOpen, isThreadOpen, isSubTaskSuggestionDrawerOpen, setSubTaskSuggestionDrawerOpen, handleClickTaskUpdate, handleLanguageCloseMenu, handleCloseGroupMenu, handleOpenGroupDrawer, handleclickAttherate, handleChange, handleCloseMemberDrawer, handleSelectedGroupmenu, handleMessageSend, handleUpdateTaskApproval, handleViewThreadClickTaskApprovalTab, handleSendTempMsg, handleNotificationPreference, handleDateTimeUpdate, handleAddgroupMember, handleSearchInputChange, handleUpdateGroupname, handleDeleteGroup, handleOnDeleteInput, handleOnInputChange, handleEditGroup, handleOnChangeNewMessage, handleReadStatusDrawer, handleDisablePrivateChat, handleBacktoMessage, handlegetThreadMessages, handleSendGoogleAttachment, handleCloseGoogleDrawer, handleClickGoogle, handleClickCloudStorage, handleCloseCloudDrawer, handleSendCloudAttachment, handleSendYouTubeAttachment, handleCloseYoutubeDrawer, handleClickYouTube, setTaskModalDeatils, taskModalDeatils, isSearchGroupInfoOpen, handleSearch, setIsSearchGroupInfoOpen, searchInputValue, setSearchInputValue, filteredMessageList, isSearching, highlightText, leaveCompleteTask, setLeaveCompleteTask, isTaskUpdateTypeModalOpen, setIsTaskUpdateTypeModalOpen }
    = useTabState({
      pubnub,
      setFilterChecked,
      setNewMessages,
      setisTopicOpen,
      newMessages,
      setAddpeopledarwer,
      groupname,
      setGroupname,
      setShowSidebar,
      setShareAiText,
      isShareAiText,
    });
  // The message lists, Topics and Threads are memoized: give them handlers
  // that keep their identity, so typing in the message box (which re-renders
  // this component on every keystroke) doesn't re-render every message.
  const stable = useStableCallbacks({
    handleSendTempMsg,
    handleAddgroupMember,
    handlegetThreadMessages,
    handleBacktoMessage,
    handleReadStatusDrawer,
    handleClickTaskUpdate,
    handleSearch,
    handleSearchInputChange,
    highlightText,
    handleSelectedTopic,
  });
  const appContent = t("AppContent", { returnObjects: true });
  // eslint-disable-next-line no-unused-vars
  const [profileViewData, setProfileViewData] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [isProfileViewOpen, setProfileViewModal] = useState(false);
  const [selectedSubTask, setSelectedSubTask] = useState([]);
  const aiComponentRef = useRef(null);

  // eslint-disable-next-line no-unused-vars
  const SmallActionButton = createStyledIndicatorButton("#DB0011");
  const { selectedGroup, currentHomeIndexTab, isAiScreenActive, showStarMessage, isAccountSwitchLoading, archiveGroupList } = useAppSelectors();
  const isThreadScreen = session.get("isThreadScreen");
  const isThreadListOpen = useSelector(
    (state) => state?.localAppReducer?.isThreadListOpen,
  );
  const [isTopicsCollapsed, setTopicsCollapsed] = useState(false);
  const [isThreadsCollapsed, setThreadsCollapsed] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);

  // eslint-disable-next-line no-unused-vars
  const handleGroupProfileBadgeClick = (
    data,
    isGroup,
    isBuyerSellerGroup = false,
  ) => {
    const viewData = {
      companyName:
        data?.accountDetails?.subscriberFirmName ||
        data?.activeSubscriber?.subscriberFirmName,
      userName: isGroup
        ? null
        : data?.name || `${data?.firstName} ${data?.lastName}`,
      industryName:
        data?.accountDetails?.subscriberAccountIndustry ||
        data?.activeSubscriber?.subscriberAccountIndustry,
      cityName: data?.accountDetails?.city || data?.city,
      industry:
        data?.accountDetails?.subscriberAccountIndustry ||
        data?.subscriberAccountIndustry,
      type:
        data?.accountDetails?.subscriberAccountType ||
        data?.subscriberAccountType,
      countryName: data?.accountDetails?.country || data?.country,
      profileBrief: data?.accountDetails?.profileBrief || data?.profileBrief,
      profileImgUrl: data?.accountDetails?.profileImgUrl || data?.profileImgUrl,
      coverImgUrl: data?.accountDetails?.coverImgUrl || data?.coverImgUrl,
      isGroup: isGroup,
      isBuyerSellerGroup: isBuyerSellerGroup,
      website: data?.accountDetails?.website || data?.website,
      linkedin: data?.accountDetails?.linkedin || data?.linkedin,
      joinedDate: data?.joinedDate
        ? new Date(
          Number(String(data?.joinedDate).slice(0, 13)),
        ).toLocaleDateString()
        : data?.joinedDate,
      memberCount: data?.memberCount || data?.memberCount,
      createdDate: data?.createdDate
        ? new Date(
          Number(String(data?.createdDate).slice(0, 13)),
        ).toLocaleDateString()
        : data?.createdDate,
      groupName: data?.name,
      // Lets Group Information follow live edits of this group.
      groupId: isGroup ? data?.id : undefined,
      groupOwner: data?.createdByUserDetails
        ? `${data.createdByUserDetails.firstName || ""} ${data.createdByUserDetails.lastName || ""
          }`.trim()
        : "-",
      description: data?.description,
      email: data?.createdByUserDetails?.email,
    };
    setProfileViewData(viewData);
    setProfileViewModal(true);
  };

  const dispatch = useDispatch();

  // Pinned chat-screen shortcut icons: dragged in from the "More" popover,
  // up to MAX_PINNED_SHORTCUTS, persisted per user in localStorage.
  const [pinnedShortcuts, setPinnedShortcuts] = useState(DEFAULT_PINNED_SHORTCUTS);
  const [activeDragShortcutId, setActiveDragShortcutId] = useState(null);
  const pinnedShortcutsLoadedRef = useRef(false);
  const moreMenuAnchorRef = useRef(null);
  const shortcutSensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 8 } }),
  );

  useEffect(() => {
    if (!currentUserData?.id) return;
    const stored = localStorage.getItem(
      `arkchatPinnedShortcuts_${currentUserData.id}`,
    );
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        if (Array.isArray(parsed)) {
          setPinnedShortcuts(parsed.slice(0, MAX_PINNED_SHORTCUTS));
        }
      } catch (err) {
        // ignore malformed local storage value
      }
    }
    pinnedShortcutsLoadedRef.current = true;
  }, [currentUserData?.id]);

  useEffect(() => {
    if (!currentUserData?.id || !pinnedShortcutsLoadedRef.current) return;
    localStorage.setItem(
      `arkchatPinnedShortcuts_${currentUserData.id}`,
      JSON.stringify(pinnedShortcuts),
    );
  }, [pinnedShortcuts, currentUserData?.id]);

  // Add Group Members, Group Members List, Group Files, the cloud storage
  // drawer, Google and Youtube all dock to the same spot — opening one
  // should replace whichever of the others is already open instead of
  // stacking on top of it.
  const openGroupDrawersRef = useRef({});
  useEffect(() => {
    const current = {
      addMember: isAddPeopledarwer,
      groupMembers: isGroupmembermenu,
      mediaFiles: isMediaFilesOpen,
      cloudProvider: Boolean(attachmentdrawer?.cloudProvider),
      youtube: Boolean(attachmentdrawer?.isYoutube),
      google: Boolean(attachmentdrawer?.isGoogle),
    };
    const previous = openGroupDrawersRef.current;
    const justOpened = Object.keys(current).find(
      (key) => current[key] && !previous[key],
    );

    if (justOpened) {
      if (justOpened !== "addMember" && isAddPeopledarwer) {
        handleCloseAddPeopleDrawer();
      }
      if (justOpened !== "groupMembers" && isGroupmembermenu) {
        handleCloseMemberDrawer();
      }
      if (justOpened !== "mediaFiles" && isMediaFilesOpen) {
        setMediaFilesOpen(false);
      }
      if (justOpened !== "cloudProvider" && attachmentdrawer?.cloudProvider) {
        handleCloseCloudDrawer();
      }
      if (justOpened !== "youtube" && attachmentdrawer?.isYoutube) {
        handleCloseYoutubeDrawer();
      }
      if (justOpened !== "google" && attachmentdrawer?.isGoogle) {
        handleCloseGoogleDrawer();
      }
    }

    openGroupDrawersRef.current = current;
  }, [
    isAddPeopledarwer,
    isGroupmembermenu,
    isMediaFilesOpen,
    attachmentdrawer?.cloudProvider,
    attachmentdrawer?.isYoutube,
    attachmentdrawer?.isGoogle,
  ]);

  const handleShortcutAction = (shortcutId) => {
    switch (shortcutId) {
      case "members":
        handleSelectedGroupmenu({ value: "members" });
        break;
      case "addMember":
        handleAddgroupMember();
        break;
      case "files":
        setMediaFilesOpen(true);
        break;
      case "star":
        selectedGroup && dispatch(handleStarMsgScreen(!showStarMessage));
        dispatch(handleScrollToBottom(true));
        break;
      default:
        break;
    }
  };

  const handleUnpinShortcut = (shortcutId) => {
    setPinnedShortcuts(pinnedShortcuts.filter((id) => id !== shortcutId));
  };

  const handleShortcutDragEnd = ({ active, over }) => {
    setActiveDragShortcutId(null);
    if (!over || over.id !== PINNED_SHORTCUTS_DROPZONE_ID) return;
    const shortcutId = active?.id;
    if (!shortcutId || pinnedShortcuts.includes(shortcutId)) return;
    if (pinnedShortcuts.length >= MAX_PINNED_SHORTCUTS) {
      dispatch(
        showToastMsg(`You can pin up to ${MAX_PINNED_SHORTCUTS} icons on the chat screen.`),
      );
      return;
    }
    // Newly dragged-in icons always take the first slot.
    setPinnedShortcuts([shortcutId, ...pinnedShortcuts]);
  };

  const handleShortcutDragStart = ({ active }) => {
    setActiveDragShortcutId(active?.id || null);
  };

  const isShortcutVisible = (shortcutId) => {
    if (currentHomeIndexTab !== 0) return false;
    if (shortcutId === "files") return true;
    if (isAiScreenActive) return false;
    if (
      (shortcutId === "addMember" || shortcutId === "members" || shortcutId === "star") &&
      !selectedGroup?.isGroup
    ) {
      return false;
    }
    if (
      shortcutId === "addMember" &&
      !canManageGroup(currentUserData, selectedGroup?.permissionType, selectedGroup?.isExternal)
    ) {
      return false;
    }
    return true;
  };

  const handleDroppedFiles = (files) => {
    const maxFiles = 5;
    if (files?.length + attachment.length + fileAttachment.length > maxFiles) {
      dispatch(showToastMsg(`You can only select up to 5 attachment.`));
      return;
    }

    const fileListWithIds = files.map((file) => ({
      id: generateUniqueId(file?.name),
      file: file,
    }));

    setFileAttachment([...fileAttachment, ...fileListWithIds]);
  };

  const threadInput = ({ hideSuggestBtn = false }) => (
    <ThreadChatInputControl
      handleclickAttherate={handleclickAttherate}
      handleMessageSend={handleMessageSend}
      handleOnChangeNewMessage={handleOnChangeNewMessage}
      newMessages={newMessages}
      handleClickYouTube={handleClickYouTube}
      setFileAttachment={setFileAttachment}
      handleClickGoogle={handleClickGoogle}
      handleClickCloudStorage={handleClickCloudStorage}
      fileAttachment={fileAttachment}
      attachment={attachment}
      isThreadTaskTypeModalOpen={isThreadTaskTypeModalOpen}
      setisTopicOpen={setisTopicOpen}
      setMoveTopicTriggered={setMoveTopicTriggered}
      isTopicOpen={isTopicOpen}
      setAttachment={setAttachment}
      setIsThreadTaskTypeModalOpen={setIsThreadTaskTypeModalOpen}
      replyParentMsg={replyParentMsg}
      setReplyParentMsg={setReplyParentMsg}
      selectedGroup={selectedGroup}
      setMessageType={setMessageType}
      selectRecipientsDrawerOpen={selectRecipientsDrawerOpen}
      taskAssignedUser={taskAssignedUser}
      setTaskModalDeatils={setTaskModalDeatils}
      taskModalDeatils={taskModalDeatils}
      isThreadScreenFromTaskApproval={isThreadScreenFromTaskApproval}
      isPrivateChatOn={
        (groupList?.find((item) => item?.pnId === selectedGroup?.pnId) ||
          archiveGroupList?.find((item) => item?.pnId === selectedGroup?.pnId))
          ?.isPrivateChatOn
      }
      isTaskUpdateOpen={isTaskUpdateOpen}
      isThreadScreen={isThreadScreen}
      setPricingDrawerOpen={setPricingDrawerOpen}
      stepper={stepper}
      selectedRecipients={selectedRecipients}
      isDisableAssignTaskBtn={
        selectedRecipients?.selectedInternalRecipients?.length !== 0 ||
        selectedRecipients?.selectedExternalRecipients?.length !== 0
      }
      isSubTaskSuggestionDrawerOpen={isSubTaskSuggestionDrawerOpen}
      setSubTaskSuggestionDrawerOpen={setSubTaskSuggestionDrawerOpen}
      hideSuggestBtn={hideSuggestBtn}
    />
  );

  const chatInputWrapper = () => (
    <ChatInputWrapper
      handleclickAttherate={handleclickAttherate}
      handleMessageSend={handleMessageSend}
      handleOnChangeNewMessage={handleOnChangeNewMessage}
      newMessages={newMessages}
      handleClickYouTube={handleClickYouTube}
      setFileAttachment={setFileAttachment}
      handleClickGoogle={handleClickGoogle}
      handleClickCloudStorage={handleClickCloudStorage}
      fileAttachment={fileAttachment}
      attachment={attachment}
      isTaskTypeModalOpen={isTaskTypeModalOpen}
      setisTopicOpen={setisTopicOpen}
      setMoveTopicTriggered={setMoveTopicTriggered}
      isTopicOpen={isTopicOpen}
      setAttachment={setAttachment}
      setIsTaskTypeModalOpen={setIsTaskTypeModalOpen}
      replyParentMsg={replyParentMsg}
      setReplyParentMsg={setReplyParentMsg}
      selectedGroup={selectedGroup}
      setMessageType={setMessageType}
      selectRecipientsDrawerOpen={selectRecipientsDrawerOpen}
      taskAssignedUser={taskAssignedUser}
      setTaskModalDeatils={setTaskModalDeatils}
      taskModalDeatils={taskModalDeatils}
      isThreadScreenFromTaskApproval={
        isThreadScreenFromTaskApproval
      }
      isPrivateChatOn={
        (groupList?.find(
          (item) => item?.pnId === selectedGroup?.pnId,
        ) || archiveGroupList?.find(
          (item) => item?.pnId === selectedGroup?.pnId,
        ))?.isPrivateChatOn
      }
      isTaskUpdateOpen={isTaskUpdateOpen}
      isThreadScreen={isThreadScreen}
      setPricingDrawerOpen={setPricingDrawerOpen}
      stepper={stepper}
      selectedRecipients={selectedRecipients}
      isDisableAssignTaskBtn={
        selectedRecipients?.selectedInternalRecipients
          ?.length !== 0 ||
        selectedRecipients?.selectedExternalRecipients
          ?.length !== 0
      }
    />
  )

  return (
    <>
      <Box position={"relative"}>
        <DndContext
          sensors={shortcutSensors}
          collisionDetection={closestCenter}
          onDragStart={handleShortcutDragStart}
          onDragEnd={handleShortcutDragEnd}
          onDragCancel={() => setActiveDragShortcutId(null)}
        >
          <StyledSubHeadingBox>
            <Box
              flexGrow={"1"}
              minWidth={0}
              display={"flex"}
              alignItems={"center"}
              justifyContent={"left"}
              px={"0.5rem"}
            >
              {selectedGroup &&
                !isAiScreenActive && (
                  <GroupInfoHeader
                    setMediaFilesOpen={setMediaFilesOpen}
                    handleBacktoMessage={handleBacktoMessage}
                    handleSearch={handleSearch}
                    transparent
                    isPreviewOpen={Boolean(previewFile)}
                    onClosePreview={() => setPreviewFile(null)}
                  />
                )}
            </Box>
            <Box display={"flex"} alignItems={"center"} flexShrink={0}>
              <Tabs
                value={currentHomeIndexTab}
                onChange={(event, newValue) => {
                  handleChange(event, newValue);
                }}
                TabIndicatorProps={{
                  style: { backgroundColor: "#183243" },
                }}
                sx={classes.Tabs}
              >

                <Tab disableRipple sx={classes.tabs} label={appContent?.KEY109} />
                {/* Track Work/Performance don't apply to DMs — only a real group. */}
                {(!selectedGroup || selectedGroup?.isGroup) && (
                  <Tab disableRipple sx={classes.tabs} label="Track Work" />
                )}
                {(!selectedGroup || selectedGroup?.isGroup) && (
                  <Tab disableRipple sx={classes.tabs} label="Track Performance" />
                )}
                {/* <Tab disableRipple sx={classes.tabs} label={appContent?.KEY110} />
              <Tab disableRipple sx={classes.tabs} label={appContent?.KEY111} /> */}
              </Tabs>
            </Box>

            <PinnedShortcutsRow
              pinnedShortcuts={pinnedShortcuts}
              isShortcutVisible={isShortcutVisible}
              showStarMessage={showStarMessage}
              selectedGroup={selectedGroup}
              onShortcutAction={handleShortcutAction}
            />

            {currentHomeIndexTab === 0 && (
              <LableToolTip title={"More"}>
                <Box display="flex" mr={0.75}>
                  <Button
                    ref={moreMenuAnchorRef}
                    variant="outlined"
                    disabled={!selectedGroup}
                    onClick={handleOpenGroupDrawer}
                    sx={{
                      backgroundColor: "#ffff",
                      borderColor: "#000000",
                      color: "#000000",
                      width: "30px",
                      height: "30px",
                      minWidth: "unset",
                      minHeight: "unset",
                      padding: "4px",
                      borderRadius: "0.15rem",
                      "&:hover": {
                        backgroundColor: "#ffff",
                        borderColor: "#000000",
                        color: "#000000",
                      },
                    }}
                  >
                    <SmallIcon src={groupVector} alt="More" />
                  </Button>
                </Box>
              </LableToolTip>
            )}
          </StyledSubHeadingBox>

          <ChatMoreMenu
            anchorEl={moreMenuAnchorRef.current}
            open={isGroupmenuOpen}
            onClose={handleCloseGroupMenu}
            pinnedShortcuts={pinnedShortcuts}
            activeDragShortcutId={activeDragShortcutId}
            onShortcutAction={handleShortcutAction}
            onUnpinShortcut={handleUnpinShortcut}
            onOpenCloudStorage={handleClickCloudStorage}
            isShortcutVisible={isShortcutVisible}
          />
        </DndContext>

        <Box display={"flex"} alignItems={"stretch"}>
          {previewFile ? (
            <Box sx={classes.previewPanelBox}>
              <FilePreview file={previewFile} />
            </Box>
          ) : (
            <>
              {[0, 1, 2].includes(currentHomeIndexTab) && isTopicOpen && (
                <Box
                  sx={
                    isTopicsCollapsed
                      ? classes.panelBoxCollapsed
                      : classes.panelBox
                  }
                >
                  <Topics
                    setisTopicOpen={setisTopicOpen}
                    handleSelectedTopic={stable.handleSelectedTopic}
                    setMoveTopicTriggered={setMoveTopicTriggered}
                    isMoveTopicTriggered={isMoveTopicTriggered}
                    moveTopicMsgId={moveTopicMsgId}
                    setMoveTopicMsgId={setMoveTopicMsgId}
                    isCollapsed={isTopicsCollapsed}
                    setCollapsed={setTopicsCollapsed}
                  />
                </Box>
              )}
              {[0, 1].includes(currentHomeIndexTab) && isThreadListOpen && (
                <Box
                  sx={
                    isThreadsCollapsed
                      ? classes.panelBoxCollapsed
                      : classes.panelBox
                  }
                >
                  <Threads
                    isCollapsed={isThreadsCollapsed}
                    setCollapsed={setThreadsCollapsed}
                  />
                </Box>
              )}
            </>
          )}
          <Box flex={1} minWidth={0}>

            <TabPanel value={currentHomeIndexTab} index={0}>
              <StyledChatContainer>
                {selectedGroup?.isGroup && isAiScreenActive && (
                  <ScreenSearchSection
                    setisTopicOpen={setisTopicOpen}
                    setMediaFilesOpen={setMediaFilesOpen}
                    isTopicOpen={isTopicOpen}
                    selectedGroup={selectedGroup}
                    handleAddgroupMember={handleAddgroupMember}
                    setAiQueryHistory={setAiQueryHistory}
                    setTempAiQuery={setTempAiQuery}
                    setShareAiText={setShareAiText}
                    setShowStaredAiHistory={setShowStaredAiHistory}
                    showStaredAiHistory={showStaredAiHistory}
                    setSelectedAnswer={setSelectedAnswer}
                    isAiQueryHistory={isAiQueryHistory}
                    handleBacktoMessage={handleBacktoMessage}
                    isSearchGroupInfoOpen={isSearchGroupInfoOpen}
                    handleSearch={handleSearch}
                    isPrivateChatOn={
                      (groupList?.find((item) => item?.pnId === selectedGroup?.pnId) ||
                        archiveGroupList?.find((item) => item?.pnId === selectedGroup?.pnId))
                        ?.isPrivateChatOn
                    }
                    aiComponentRef={aiComponentRef}
                  />
                )}

                <>
                  {isSyncing && !isAccountSwitchLoading ? (
                    <LoadingSpinner />
                  ) : (
                    <FileDropZone
                      onFilesDropped={handleDroppedFiles}
                      disabled={!selectedGroup || isAiScreenActive}
                      style={{
                        height:
                          selectedGroup?.isGroup && isAiScreenActive
                            ? "calc(100% - 36px)"
                            : "100%",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          height: "100%",
                          overflow: "hidden",
                        }}
                      >
                        <Box sx={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
                          {selectedGroup ? (
                            <>
                              {isAiScreenActive ? (
                                <>
                                  <AIQueryPage
                                    isAiQueryHistory={isAiQueryHistory}
                                    setAiQueryHistory={setAiQueryHistory}
                                    tempAiQuery={tempAiQuery}
                                    setTempAiQuery={setTempAiQuery}
                                    showTempQuery={showTempQuery}
                                    setShowTempQuery={setShowTempQuery}
                                    isShareAiText={isShareAiText}
                                    setShareAiText={setShareAiText}
                                    setNewMessages={setNewMessages}
                                    setShowStaredAiHistory={setShowStaredAiHistory}
                                    showStaredAiHistory={showStaredAiHistory}
                                    setSelectedAnswer={setSelectedAnswer}
                                    selecteAnswer={selecteAnswer}
                                    setAiQueryValue={setAiQueryValue}
                                    aiQueryValue={aiQueryValue}
                                    setFileAttachment={setFileAttachment}
                                    handleClickGoogle={handleClickGoogle}
                                    handleClickCloudStorage={handleClickCloudStorage}
                                    handleClickYouTube={handleClickYouTube}
                                    fileAttachment={fileAttachment}
                                    attachment={attachment}
                                    isTaskUpdateOpen={isTaskUpdateOpen}
                                    setAttachment={setAttachment}
                                    setReplyParentMsg={setReplyParentMsg}
                                    replyParentMsg={replyParentMsg}
                                    handleMessageSend={handleMessageSend}
                                    handleclickAttherate={handleclickAttherate}
                                    newMessages={newMessages}
                                    selectedGroup={selectedGroup}
                                    isThreadScreen={isThreadScreen}
                                    setisTopicOpen={setisTopicOpen}
                                    setMoveTopicTriggered={setMoveTopicTriggered}
                                    setMoveTopicMsgId={setMoveTopicMsgId}
                                    setTaskData={setTaskData}
                                    setTaskUpdateOpen={setTaskUpdateOpen}
                                    ref={aiComponentRef}
                                    chatInputWrapper={chatInputWrapper}
                                  />
                                </>
                              ) : (
                                <>
                                  {isSearchGroupInfoOpen && showStarMessage && (
                                    <Box
                                      display={"flex"}
                                      marginTop="0px"
                                      space={3}
                                      justifyContent={"center"}
                                      alignItems={"center"}
                                    >
                                      <SearchInputFromGroupInfo
                                        setMediaFilesOpen={setMediaFilesOpen}
                                        handleBacktoMessage={handleBacktoMessage}
                                        searchInputValue={searchInputValue}
                                        handleSearchInputChange={
                                          handleSearchInputChange
                                        }
                                        filteredMessageList={filteredMessageList}
                                        handleSearch={handleSearch}
                                        type="main"
                                        isSearching={isSearching}
                                      />
                                    </Box>
                                  )}

                                  <MessageList
                                    handleSendTempMsg={stable.handleSendTempMsg}
                                    handleAddgroupMember={stable.handleAddgroupMember}
                                    setMediaFilesOpen={setMediaFilesOpen}
                                    setMoveTopicTriggered={setMoveTopicTriggered}
                                    setMoveTopicMsgId={setMoveTopicMsgId}
                                    handlegetThreadMessages={stable.handlegetThreadMessages}
                                    handleBacktoMessage={stable.handleBacktoMessage}
                                    setisTopicOpen={setisTopicOpen}
                                    handleReadStatusDrawer={stable.handleReadStatusDrawer}
                                    setTaskData={setTaskData}
                                    setTaskUpdateOpen={setTaskUpdateOpen}
                                    handleClickTaskUpdate={stable.handleClickTaskUpdate}
                                    setReplyParentMsg={setReplyParentMsg}
                                    progress={progress}
                                    isSearchGroupInfoOpen={isSearchGroupInfoOpen}
                                    handleSearch={stable.handleSearch}
                                    setIsSearchGroupInfoOpen={setIsSearchGroupInfoOpen}
                                    isPrivateChatOn={
                                      (groupList?.find(
                                        (item) => item?.pnId === selectedGroup?.pnId,
                                      ) || archiveGroupList?.find(
                                        (item) => item?.pnId === selectedGroup?.pnId,
                                      ))?.isPrivateChatOn
                                    }
                                    highlightText={stable.highlightText}
                                    searchInputValue={searchInputValue}
                                    onPreviewFile={setPreviewFile}
                                  />
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              <Stack
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  height: "100%",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  src={selectGroupicon}
                                  style={{ height: "100px" }}
                                  alt=""
                                />
                              </Stack>
                            </>
                          )}
                        </Box>

                        {!isAiScreenActive && selectedGroup && (
                          chatInputWrapper()
                        )}
                      </Box>
                    </FileDropZone>
                  )}
                </>

                <Drawer
                  sx={{ zIndex: 1202 }}
                  open={isCreategroupOpen}
                  anchor={"right"}
                >
                  <CreateGroup
                    handleClosegroupdrawer={handleClosegroupdrawer}
                    handlesavearkchatgroup={handlesavearkchatgroup}
                    handleNameChange={handleNameChange}
                    handleDescriptionChange={handleDescriptionChange}
                    newGroupDescription={newGroupDescription}
                    newGroupName={newGroupName}
                    isRequired={isRequired}
                  />
                </Drawer>

                <Drawer
                  sx={{ zIndex: 1202 }}
                  open={isLanguageMenuOpen}
                  anchor={"right"}
                >
                  <LanguageList
                    handleLanguageCloseMenu={handleLanguageCloseMenu}
                    setLanguageMenuOpen={setLanguageMenuOpen}
                    selectedGroup={selectedGroup}
                  />
                </Drawer>

                <Drawer
                  sx={{ zIndex: 1202, ...leftOverlayDrawerSx }}
                  open={isMediaFilesOpen}
                  anchor={"left"}
                  variant="persistent"
                >
                  <MediaFiles
                    setMediaFilesOpen={setMediaFilesOpen}
                    isMediaFilesOpen={isMediaFilesOpen}
                    isThreadScreen={isThreadScreen}
                    handlegetThreadMessages={handlegetThreadMessages}
                    onPreviewFile={setPreviewFile}
                  />
                </Drawer>

                <AddMemberGroupDrawer
                  isaddmemberOpen={isAddPeopledarwer}
                  handleCloseAddPeopleDrawer={handleCloseAddPeopleDrawer}
                  selectedGroup={selectedGroup}
                />

                <GroupMemberDrawer
                  handleCloseMemberDrawer={handleCloseMemberDrawer}
                  isGroupmembermenu={isGroupmembermenu}
                />
              </StyledChatContainer>
            </TabPanel>
            <TabPanel value={currentHomeIndexTab} index={1}>
              <WorkTrackingListTab
                setShowSidebar={setShowSidebar}
                handleClickTaskUpdate={handleClickTaskUpdate}
                handleViewThreadClick={handleViewThreadClickTaskApprovalTab}
                currentHomeIndexTab={currentHomeIndexTab}
                setSideBarOpen={setSideBarOpen}
                filterActive={filterActive}
                setFilterActive={setFilterActive}
                groupActive={groupActive}
                setGroupActive={setGroupActive}
                sidebarLeft={sidebarLeft}
                setSidebarLeft={setSidebarLeft}
              />
            </TabPanel>
            <TabPanel value={currentHomeIndexTab} index={2}>
              <PerformanceTab
                currentHomeIndexTab={currentHomeIndexTab}
                isSideBarOpen={isSideBarOpen}
                isTopicOpen={isTopicOpen}
              />
            </TabPanel>
            <TabPanel value={currentHomeIndexTab} index={3}>
              <TaskListTab
                setShowSidebar={setShowSidebar}
                handleClickTaskUpdate={handleClickTaskUpdate}
                handleViewThreadClick={handleViewThreadClickTaskApprovalTab}
                currentHomeIndexTab={currentHomeIndexTab}
                setSideBarOpen={setSideBarOpen}
                filterActive={filterActive}
                setFilterActive={setFilterActive}
                groupActive={groupActive}
                setGroupActive={setGroupActive}
                sidebarLeft={sidebarLeft}
                setSidebarLeft={setSidebarLeft}


              // taskTabValue={taskTabValue}
              // setTaskTabValue={setTaskTabValue}
              // selectedTaskmember={selectedTaskmember}
              // setSelectedTaskMember={setSelectedTaskMember}
              // selectedTaskGroup={selectedTaskGroup}
              // setSelectedTaskGroup={setSelectedTaskGroup}
              // filterChecked={filterChecked}
              // setFilterChecked={setFilterChecked}
              // // handleApplyTaskFilter={handleApplyTaskFilter}
              // handlecreategroup={handlecreategroup}
              // handleGroupProfileBadgeClick={handleGroupProfileBadgeClick}
              // SmallActionButton={SmallActionButton}

              // handlegroupItemclick={handleTaskGroupOnClick}
              // showInfoMessage={showInfoMessage}
              // setShowInfoMessage={setShowInfoMessage}
              />
            </TabPanel>
            <TabPanel value={currentHomeIndexTab} index={4}>
              <ApprovalListTab
                setShowSidebar={setShowSidebar}
                currentHomeIndexTab={currentHomeIndexTab}
                filterActive={filterActive}
                setFilterActive={setFilterActive}
                setSideBarOpen={setSideBarOpen}
                groupActive={groupActive}
                setGroupActive={setGroupActive}
                sidebarLeft={sidebarLeft}
                setSidebarLeft={setSidebarLeft}
                handleClickTaskUpdate={handleClickTaskUpdate}
                handleViewThreadClick={handleViewThreadClickTaskApprovalTab}
              />
            </TabPanel>

          </Box>
        </Box>

        {/* common drawers */}
        <>
          {/* These dock the same way as the Chats-tab-only drawers below, but
              are reachable from the Message Thread panel too (e.g. from
              Track Work), which is mounted outside the Chats TabPanel — so
              they must live here rather than inside TabPanel index={0}. */}
          <Drawer
            sx={{ zIndex: 1202, ...leftOverlayDrawerSx }}
            open={attachmentdrawer?.isYoutube}
            anchor={"left"}
            variant="persistent"
          >
            <YouTubeAttachmentDrawer
              handleCloseYoutubeDrawer={handleCloseYoutubeDrawer}
              handleSendYouTubeAttachment={handleSendYouTubeAttachment}
              fileAttachment={fileAttachment}
              attachment={attachment}
            />
          </Drawer>

          <Drawer
            sx={{ zIndex: 1202, ...leftOverlayDrawerSx }}
            open={attachmentdrawer?.isGoogle}
            anchor={"left"}
            variant="persistent"
          >
            <GoogleAttachmentDrawer
              handleCloseGoogleDrawer={handleCloseGoogleDrawer}
              handleSendGoogleAttachment={handleSendGoogleAttachment}
              fileAttachment={fileAttachment}
              attachment={attachment}
            />
          </Drawer>

          <Drawer
            sx={{ zIndex: 1202, ...leftOverlayDrawerSx }}
            open={Boolean(attachmentdrawer?.cloudProvider)}
            anchor={"left"}
            variant="persistent"
          >
            <CloudStorageDrawer
              provider={attachmentdrawer?.cloudProvider}
              handleCloseCloudDrawer={handleCloseCloudDrawer}
              handleSendCloudAttachment={handleSendCloudAttachment}
              fileAttachment={fileAttachment}
              attachment={attachment}
              onPreviewFile={setPreviewFile}
            />
          </Drawer>

          <Drawer
            disableEnforceFocus
            hideBackdrop
            anchor={"right"}
            open={isThreadOpen}
            sx={{ zIndex: 1202, pointerEvents: "none", ...rightOverlayDrawerSx }}
          >
            <FileDropZone
              onFilesDropped={handleDroppedFiles}
              disabled={!selectedGroup}
              style={{ height: "100%" }}
            >
              <MessageThreadDrawer
                setMessageThreadOpen={setThreadOpen}
                handleSendTempMsg={stable.handleSendTempMsg}
                setMediaFilesOpen={setMediaFilesOpen}
                setMoveTopicTriggered={setMoveTopicTriggered}
                setMoveTopicMsgId={setMoveTopicMsgId}
                handlegetThreadMessages={stable.handlegetThreadMessages}
                handleBacktoMessage={stable.handleBacktoMessage}
                setisTopicOpen={setisTopicOpen}
                isTopicOpen={isTopicOpen}
                filteredMessageList={filteredMessageList}
                handleReadStatusDrawer={stable.handleReadStatusDrawer}
                setTaskData={setTaskData}
                setTaskUpdateOpen={setTaskUpdateOpen}
                handleClickTaskUpdate={stable.handleClickTaskUpdate}
                setReplyParentMsg={setReplyParentMsg}
                progress={progress}
                searchInputValue={searchInputValue}
                setSearchInputValue={setSearchInputValue}
                isSearchGroupInfoOpen={isSearchGroupInfoOpen}
                handleSearch={stable.handleSearch}
                handleAddgroupMember={stable.handleAddgroupMember}
                handleSearchInputChange={stable.handleSearchInputChange}
                isPrivateChatOn={
                  (groupList?.find((item) => item?.pnId === selectedGroup?.pnId) ||
                    archiveGroupList?.find((item) => item?.pnId === selectedGroup?.pnId))
                    ?.isPrivateChatOn
                }
                chatInputControl={threadInput}
                onPreviewFile={setPreviewFile}
              />
            </FileDropZone>
          </Drawer>
          <Drawer
            disableEnforceFocus
            // hideBackdrop={true}
            anchor={"right"}
            open={isSubTaskSuggestionDrawerOpen}
            sx={{ zIndex: 1202 }}
          >
            <SubTaskAISuggestionDrawer
              onClose={setSubTaskSuggestionDrawerOpen}
              setNewMessages={setNewMessages}
              selectedSubTask={selectedSubTask}
              setSelectedSubTask={setSelectedSubTask}
              setIsThreadTaskTypeModalOpen={setIsThreadTaskTypeModalOpen}
              setTaskModalDeatils={setTaskModalDeatils}
              handleclickAttherate={handleclickAttherate}
            />
          </Drawer>
          {isEditGroupmenu && (
            <InputDialogComponent
              title="Edit Group"
              open={isEditGroupmenu}
              handleClose={() => setEditGroupmenu(false)}
              onChange={handleOnInputChange}
              value={groupname}
              btnLabel="Update"
              inputLable="group Name"
              isType="edit"
              onClick={handleUpdateGroupname}
            />
          )}

          {isDeleteGroupmenu && (
            <InputDialogComponent
              title="Delete/ Exit Group"
              isType="delete"
              open={isDeleteGroupmenu}
              handleClose={() => {
                setDeletegroupmenu(false);
                setdeleteInputVal("");
              }}
              onChange={handleOnDeleteInput}
              value={delInputval}
              btnLabel="Delete"
              required={delrequired}
              onClick={handleDeleteGroup}
            />
          )}

          {isdisableprivatchat && (
            <InputDialogComponent
              title="Deactivate private chats & To Dos"
              isType="disableprivatechat"
              open={isdisableprivatchat}
              handleClose={() => {
                setdisableprivatechat(false);
              }}
              onChange={(event) => setdisableprivatechat(event.target.checked)}
              value={isPrivateDisableChat}
              btnLabel="save"
              disabled={
                currentUserData?.activePermission ===
                GroupLevelArkchatPermission?.USER
              }
              required={false}
              onClick={handleDisablePrivateChat}
              setPrivateDisableChat={setPrivateDisableChat}
              handleDisableEnablepvtChat={(event) =>
                setPrivateDisableChat(event.target.checked)
              }
            />
          )}

          {isdateAndTimeModalOpen && (
            <InputDialogComponent
              title="Date & time format"
              isType="date&time"
              open={isdateAndTimeModalOpen}
              handleClose={() => {
                setDatAndTimeModal(false);
                setDateFormate("");
              }}
              btnLabel="Save"
              set24Hour={set24Hour}
              setDDMMYY={setDDMMYY}
              isDDMMYY={isDDMMYY}
              setMMDDYY={setMMDDYY}
              isMMDDYY={isMMDDYY}
              setYYMMDD={setYYMMDD}
              isYYMMDD={isYYMMDD}
              is24Hour={is24Hour}
              setDateFormate={setDateFormate}
              onClick={handleDateTimeUpdate}
            />
          )}

          {selectedGroup && (
            <Drawer
              disableEnforceFocus
              hideBackdrop={true}
              open={selectRecipientsDrawerOpen}
              anchor={"right"}
              sx={{ zIndex: isThreadOpen ? 1202 : "" }}
            >
              <AssignTaskDrawers
                setSelectRecipientsDrawerOpen={setSelectRecipientsDrawerOpen}
                setMessageType={setMessageType}
                msgType={msgType}
                selectedRecipients={selectedRecipients}
                setSelectedRecipients={setSelectedRecipients}
                taskAssignedUser={taskAssignedUser}
                setTaskAssignedUser={setTaskAssignedUser}
                dueTime={dueTime}
                setDueTime={setDueTime}
                dueDate={dueDate}
                setDueDate={setDueDate}
                priority={priority}
                setPriority={setPriority}
                isRepeat={isRepeat}
                setRepeat={setRepeat}
                repeatType={repeatType}
                setRepeatType={setRepeatType}
                selecteRepeatEvery={selecteRepeatEvery}
                setSelectedRepeatEvery={setSelectedRepeatEvery}
                stepper={stepper}
                setStepper={setStepper}
                checkedType={checkedType}
                setCheckedType={setCheckedType}
                updateTaskApprovalMsg={updateTaskApprovalMsg}
                setUpdateTaskApprovalMsg={setUpdateTaskApprovalMsg}
                handleUpdateTaskApproval={handleUpdateTaskApproval}
                isTaskUpdateOpen={isTaskUpdateOpen}
                taskData={taskData}
                taskModalDeatils={taskModalDeatils}
                externalGroupMember={externalGroupMember}
                setExternalGroupMemebr={setExternalGroupMemebr}
                setTaskUpdateOpen={setTaskUpdateOpen}
                setTaskData={setTaskData}
                selectRecipientsDrawerOpen={selectRecipientsDrawerOpen}
                handleClickYouTube={handleClickYouTube}
                setFileAttachment={setFileAttachment}
                handleClickGoogle={handleClickGoogle}
                handleClickCloudStorage={handleClickCloudStorage}
                fileAttachment={fileAttachment}
                attachment={attachment}
                setAttachment={setAttachment}
                setIsTaskUpdateTypeModalOpen={setIsTaskUpdateTypeModalOpen}
                isTaskUpdateTypeModalOpen={isTaskUpdateTypeModalOpen}
                handleclickAttherate={handleclickAttherate}
                setTaskModalDeatils={setTaskModalDeatils}
                setSelectedSubTask={setSelectedSubTask}
                setNewMessages={setNewMessages}
                chatInputControl={threadInput}
              />
            </Drawer>
          )}

          <Drawer
            disableEnforceFocus
            // hideBackdrop={true}
            anchor={"right"}
            open={isTaskUpdateOpen}
            sx={{ zIndex: isThreadOpen ? 1202 : "" }}
          >
            <TaskUpdate
              selectedRecipients={selectedRecipients}
              handleUpdateTaskApproval={handleUpdateTaskApproval}
              setTaskUpdateOpen={setTaskUpdateOpen}
              setSelectRecipientsDrawerOpen={setSelectRecipientsDrawerOpen}
              setStepper={setStepper}
              taskData={taskData}
              setTaskData={setTaskData}
              setMessageType={setMessageType}
              msgType={msgType}
              selectRecipientsDrawerOpen={selectRecipientsDrawerOpen}
              handleMessageSend={handleMessageSend}
              newMessages={newMessages}
              handleClickYouTube={handleClickYouTube}
              setFileAttachment={setFileAttachment}
              handleClickGoogle={handleClickGoogle}
              handleClickCloudStorage={handleClickCloudStorage}
              fileAttachment={fileAttachment}
              attachment={attachment}
              setAttachment={setAttachment}
              stepper={stepper}
              setDueDate={setDueDate}
              setDueTime={setDueTime}
              checkedType={checkedType}
              setCheckedType={setCheckedType}
              setReplyParentMsg={setReplyParentMsg}
              updateTaskApprovalMsg={updateTaskApprovalMsg}
              setUpdateTaskApprovalMsg={setUpdateTaskApprovalMsg}
              leaveCompleteTask={leaveCompleteTask}
              setLeaveCompleteTask={setLeaveCompleteTask}
              setTaskModalDeatils={setTaskModalDeatils}
              setIsTaskUpdateTypeModalOpen={setIsTaskUpdateTypeModalOpen}
              isTaskUpdateTypeModalOpen={isTaskUpdateTypeModalOpen}
              handleclickAttherate={handleclickAttherate}
              setIsTaskTypeModalOpen={setIsTaskTypeModalOpen}
              taskModalDeatils={taskModalDeatils}
              setSelectedRecipients={setSelectedRecipients}

            />
          </Drawer>

          <Drawer
            sx={{ zIndex: 1202 }}
            open={readStatusdrawer}
            anchor={"right"}
          >
            <GrouMembeMessageReadStatus
              handleCloseMemberDrawer={() => setReadstatusdrawer(false)}
            />
          </Drawer>

          {isNotificationpreferenceModalOpen && (
            <InputDialogComponent
              title="Notification preference"
              isType="notification"
              open={isNotificationpreferenceModalOpen}
              handleClose={() => {
                setNotificationpreferenceModal(false);
                setDateFormate("");
              }}
              btnLabel="Save"
              onClick={handleNotificationPreference}
              setMobileChecked={setMobileChecked}
              setEmailChecked={setEmailChecked}
              isMobileChecked={isMobileChecked}
              isEmailChecked={isEmailChecked}
            />
          )}
        </>
      </Box>
    </>
  );
};

export default MyTabs;

